import React from "react";
import { useTranslation } from "react-i18next";
import { refreshPage } from "_common/_utils/pageUtils";

export type PopularType = "search" | "location";
export type PopularPurpose = "sale" | "rent";

export type PopularEntry = { label: string; link: string };

export function usePopularEntries(type: PopularType, purpose: PopularPurpose): PopularEntry[] {
    const { t } = useTranslation();
    const key = type === "search" ? "popularSearches" : "popularLocations";
    const items = Array.from(Array(18).keys());

    return items
        .map((x) => {
            const labelKey = `footer.${key}.${purpose}.label${x + 1}`;
            const linkKey = `footer.${key}.${purpose}.link${x + 1}`;
            return { label: t(labelKey), link: t(linkKey), labelKey };
        })
        .filter((entry) => entry.label && entry.label !== entry.labelKey)
        .map(({ label, link }) => ({ label, link }));
}

type PopularEntryLinkProps = {
    entry: PopularEntry;
    className?: string;
};

export function PopularEntryLink({ entry, className }: PopularEntryLinkProps) {
    return (
        <a
            href={entry.link}
            title={entry.label}
            className={className}
            onClick={(e) => {
                e.preventDefault();
                refreshPage(entry.link);
            }}
        >
            {entry.label}
        </a>
    );
}
